/**
 * Which crafting stations are within reach.
 *
 * Kept out of recipes.ts because that file knows nothing about the world, and
 * should not start to: a recipe is a rule, not a place.
 */

import type { World } from "../world/world.js";
import { isStove, BlockId } from "../block/registry.js";
import type { Station } from "./recipes.js";

/**
 * How far a stove counts from, in blocks.
 *
 * Generous on purpose. Judging "am I close enough" from a first-person view is
 * hard, and a player standing in front of their own stove being told there is
 * no stove would be the worst possible feedback.
 */
export const STATION_REACH = 4;

/** Every station within reach of a position. */
export function stationsNear(
  world: World, x: number, y: number, z: number,
): Set<Station> {
  const found = new Set<Station>();
  const r = STATION_REACH;
  const bx = Math.floor(x);
  const by = Math.floor(y);
  const bz = Math.floor(z);

  for (let dy = -r; dy <= r; dy++) {
    for (let dz = -r; dz <= r; dz++) {
      for (let dx = -r; dx <= r; dx++) {
        const id = world.getBlock(bx + dx, by + dy, bz + dz);
        if (isStove(id)) found.add("stove");
        // Only a vat with water in it counts: the water does the work.
        else if (id === BlockId.VatFull) found.add("vat");
        else if (id === BlockId.SpinningWheel) found.add("wheel");
      }
    }
  }
  return found;
}
